'use strict';

var text = require('./text');

module.exports = raw;

/* Stringify `raw`. */
function raw(ctx, node) {
  return ctx.dangerous ? node.value : text(ctx, node);
}



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-to-html/lib/raw.js
// module id = 176
// module chunks = 94053359063892 107818501498521